/**
 * Map auth-related error codes (from the {error,message,trace_id}
 * envelope or local provider failures) to Swedish copy.
 *
 * Kept tiny on purpose — only the codes we actually surface to users.
 * Unknown codes fall through to `message`.
 */

const COPY: Record<string, string> = {
  session_inactive:
    'Sessionen är inaktiv. Ladda om sidan eller logga in igen.',
  clerk_session_missing:
    'Sessionen är inaktiv. Ladda om sidan eller logga in igen.',
  clerk_jwt_invalid: 'Logga in igen för att fortsätta.',
  clerk_jwt_expired: 'Logga in igen för att fortsätta.',
  TOKEN_EXPIRED: 'Sessionen har gått ut. Logga in igen.',
  missing_token: 'Du behöver vara inloggad.',
  missing_clerk_jwt: 'Du behöver vara inloggad.',
  invalid_token: 'Sessionen är ogiltig. Logga in igen.',
  invalid_claims: 'Sessionen är ogiltig. Logga in igen.',
  upstream_unreachable:
    'Autentiseringstjänsten svarar inte just nu. Försök igen om en stund.',
  destinations_lookup_failed:
    'Kunde inte ladda dina arbetsytor. Försök igen om en stund.',
  token_provider_not_ready:
    'Appen håller på att starta. Försök igen om en sekund.',
};

export type AuthErrorInput = {
  error?: string;
  message?: string;
  trace_id?: string | null;
};

export function mapAuthError(input: AuthErrorInput | Error | unknown): string {
  if (input instanceof Error) {
    return COPY[input.message] ?? input.message;
  }
  if (typeof input === 'object' && input !== null) {
    const e = input as AuthErrorInput;
    if (e.error && COPY[e.error]) return COPY[e.error]!;
    if (e.message && COPY[e.message]) return COPY[e.message]!;
    if (e.error || e.message) return `${e.message ?? e.error}`;
  }
  return 'Något gick fel. Försök igen.';
}
